import { render, staticRenderFns } from "./AllInOneRegistration.vue?vue&type=template&id=d4ee1516&scoped=true&"
import script from "./AllInOneRegistration.vue?vue&type=script&lang=js&"
export * from "./AllInOneRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ee1516",
  null
  
)

export default component.exports